import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_WSPOSITIONS } from "./actionTypes";
import { getWsPositionsSuccess, getWsPositionsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* getWsPositions({ payload: { user } }) {
  try {
    const response = yield call(workstationAPI.getWSPositions, user.token);
   
    yield put(getWsPositionsSuccess(response.WSPositions, response.message));
  } catch (error) {
    yield put(getWsPositionsError(error));
  }
}

export function* watchGetWsPositions() {
  yield takeEvery(GET_WSPOSITIONS, getWsPositions);
}

function* getWsPositionsSaga() {
  yield all([fork(watchGetWsPositions)]);
}

export default getWsPositionsSaga;
